import styles from './TermosDetails.module.css'

export default function TermosDetails(){
    return(
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <h1>Termos de Uso</h1>
                    <p className={styles.data}>Última atualização: 05/01/2025</p>
                    <p>
                        Bem-vindo à <b className={styles.negrito}>DevZone Innovations! </b>
                        Ao acessar nosso site, você concorda com os seguintes Termos de Uso:
                    </p>
                </div>
                <h2>1. Aceitação dos Termos</h2>
                <p className={styles.text}>
                    O uso do site implica na aceitação integral destes Termos. 
                    Caso não concorde, recomendamos que não utilize nossos serviços.
                </p>

                <h2>2. Uso do Site</h2>
                <p className={styles.text}>
                    Você se compromete a utilizar o site apenas para 
                    fins lícitos, respeitando a legislação vigente e 
                    os direitos da DevZone e de terceiros. É proibido:
                </p>
                <ul>
                    <li>
                        Copiar, reproduzir ou distribuir qualquer conteúdo sem autorização.
                    </li>
                    <li>
                        Tentar invadir, danificar ou interferir nos sistemas do site.
                    </li>
                    <li>
                        Utilizar o site para atividades fraudulentas ou ilícitas.                    
                    </li>
                </ul>

                <h2>3. Propriedade Intelectual</h2>
                <p className={styles.text}>
                    Todo o conteúdo do site, incluindo nome, textos, imagens, 
                    logotipos, gráficos e códigos, é protegido por direitos 
                    autorais e pertence à DevZone Innovations, salvo indicação 
                    em contrário.
                </p>

                <h2>4. Limitação de Responsábilidade</h2>
                <p className={styles.text}>
                    Não garantimos que o site estará livre de erros, vírus ou interrupções. 
                    Não nos responsabilizamos por danos diretos ou indiretos causados pelo 
                    uso do site ou por links para sites de terceiros.
                </p>

                <h2>5. Modificações dos Termos</h2>
                <p className={styles.text}>
                    A DevZone pode atualizar estes Termos de Uso a qualquer momento, sem aviso prévio. 
                    É responsabilidade do usuário revisá-los periodicamente.
                </p>

                <h2>6. Encerramento de Acesso</h2>
                <p className={styles.text}>
                    Reservamo-nos o direito de suspender ou encerrar o acesso de 
                    qualquer usuário que viole estes Termos de Uso.
                </p>

                <h2>7. Contato</h2>
                <p className={styles.text}>
                    Para dúvidas, sugestões ou reclamações sobre o uso do site, 
                    entre em contato conosco:
                </p>
                <ul>
                    <li>
                        <a 
                            href='mailto:devzoneinnovations@gmail.com'> 
                            devzoneinnovations@gmail.com
                        </a>
                    </li>
                    <li>
                        <a 
                            href='https://wa.me/5511912125307'> 
                            +55 (11) 998505-0470
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
}